// src/Reducers/studentCourseTreeReducer.js
import {
  FETCH_STUDENT_COURSE_TREE_REQUEST,
  FETCH_STUDENT_COURSE_TREE_SUCCESS,
  FETCH_STUDENT_COURSE_TREE_FAILURE,
} from "../Actions/studentCourseTreeAction";

const initialState = {
  loading: false,
  treeData: [],
  error: "",
};

const studentCourseTreeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STUDENT_COURSE_TREE_REQUEST:
      return { ...state, loading: true };
    case FETCH_STUDENT_COURSE_TREE_SUCCESS:
      return { ...state, loading: false, treeData: action.payload, error: "" };
    case FETCH_STUDENT_COURSE_TREE_FAILURE:
      return { ...state, loading: false, treeData: [], error: action.payload };
    default:
      return state;
  }
};

export default studentCourseTreeReducer;
